import { adminHttpClient } from "../../../commons/adminHttpClinet"
import { TransactionsModel, TransactionsSearch } from "../../../models/dashboard/transactions/transation"


const getTransactionsByUser = (model: TransactionsSearch) : Promise<TransactionsModel> => {
    return adminHttpClient.get(`/api/Admin/AdminTransactions/get-all-transactions?SearchValue=${model.searchValue}&PageNumber=${model.pageNumber}&PageSize=${model.pageSize}&OrderDescending=${model.orderDescending}&UserId=${model.userId}&SortColumn=${model.sortColumn}&TransferStatus=${model.transferStatus}`);
}

export default getTransactionsByUser;
